// extracted by mini-css-extract-plugin
export default {"empty_table":"styles_empty_table__rgmS1","title":"styles_title__1yTZ2","description":"styles_description__vkrxy"};